/**
 * スペック値のコンポーネント
 */
export default {
    name: 'specValues',
    template: '#spec_value_component_template',
    data () {
        return {
            selected_specs: []
        };
    },
    props: {
        spec_id: {
            type: String
        },
        spec_values: {
            type: Array
        },
        modelValue: {
            type: Array
        }
    },
    watch: {
        // プロダクトカテゴリIDが変更されたら商品スペックデータを取得しなおす
        selected_specs: {
            async handler() {
                this.modelValue[this.spec_id] = this.selected_specs;
                this.$emit('update:modelValue', this.modelValue);
            },
        }
    },
    emits: ['update:modelValue'],
    methods: {
        setSelectedSpecs: function () {
            let selected_specs = '';
            let spec_value = this.spec_values[0];

            // 既にスペック情報が存在する時
            if (this.spec_id in this.modelValue) {
                let values = this.modelValue[this.spec_id];

                // スペック値が「ラジオ選択肢」 or 「整数」 or 「小数点整数」データの場合
                if (spec_value.selection_type == 0 && Array.isArray(values)) {
                    values = values[0];
                }

                selected_specs = values;

            // 複数チェックボックスの場合、初期値は空の配列
            } else if (spec_value.selection_type == 1 && spec_value.data_type == 1) {
                selected_specs = [];
            }

            this.selected_specs = selected_specs;
        },
        allSelectSpecs: function () {
            let selected_specs = [];
            this.spec_values.forEach(spec_value => {
                selected_specs.push(spec_value.spec_value_id);
            });

            this.selected_specs = selected_specs;
        }
    }
};